import React, { useState, useEffect } from "react";
import { scheduleNotification } from "utils/ui";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Switch,
  FormControlLabel,
  Button,
  TextField,
  Box
} from "@mui/material";

const AlarmSettingsDialog = ({
  open,
  onClose,
  alarmEnabled,
  onToggle,
  initialStartTime 
}) => {
  const [startTime, setStartTime] = useState(""); // 기준 시각

  // 다이얼로그 열릴 때마다 초기화
  useEffect(() => {
    if (open) {
      if (initialStartTime) {
        setStartTime(initialStartTime);
      } else {
        const now = new Date();
        const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000) // 타임존 보정
          .toISOString()
          .slice(0, 16); // yyyy-MM-ddTHH:mm 형태
        setStartTime(local);
      }
    }
  }, [open, initialStartTime]);

  // 알람 저장
  const handleSave = (offsetMinutes) => {
    if (!startTime) {
      alert("예약 기준 시간을 선택하세요.");
      return;
    }

    const selectedTimestamp = new Date(startTime).getTime();
    const alarmTimestamp = selectedTimestamp + offsetMinutes * 60 * 1000; // offsetMinutes는 ±10
    const now = Date.now();

    if (alarmTimestamp <= now) {
      alert("현재보다 과거 시간은 예약할 수 없습니다.");
      return;
    }

    scheduleNotification(
      alarmTimestamp,
      "예약 알람",
      `${offsetMinutes > 0 ? offsetMinutes : Math.abs(offsetMinutes)}분 ${offsetMinutes > 0 ? "후" : "전"} 알림`
    );

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} disableEnforceFocus>
      <DialogTitle>예약 알람 설정</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          예약 기준 시간을 선택하세요.
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={alarmEnabled}
              onChange={onToggle}
              color="primary"
            />
          }
          label={alarmEnabled ? "알림 받는 중" : "알림 끔"}
        />

        {alarmEnabled && (
          <>
            <TextField
              fullWidth
              type="datetime-local"
              label="기준 시간"
              InputLabelProps={{ shrink: true }}
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              sx={{ mt: 2 }}
            />

            <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
              선택한 시간 기준으로 알람을 예약합니다.
            </Typography>
          </>
        )}

          {alarmEnabled && (
          <Box sx={{display:'flex',justifyContent:'space-between',width:'100%', gap:1, pt:1}}>
            <Button
              onClick={() => handleSave(-10)}
              variant="outlined"
              color="secondary"
            >
              10분 전 알람
            </Button>
            <Button
              onClick={() => handleSave(10)}
              variant="contained"
              color="primary"
            >
              10분 후 알람
            </Button>
          </Box>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlarmSettingsDialog;
